import React, { Component } from 'react'
import * as R from 'ramda'
import { connect } from 'react-redux'
import TemplatesList from './TemplatesList'
import ActionBar from './ActionBar'
import RightPanel from 'components/RightPanel'
import { templates } from 'selectors/entities'
import actionBarActions from 'actions/actionbar'
import attachmentOverlayActions from 'actions/attachmentOverlayActions'
import AttachmentOverlay from 'components/AttachmentOverlay'
import dataActions from 'actions/dataActions'
import LeftNav from 'material-ui/Drawer'
import LeftNavMenu from 'components/LeftNavMenu'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import ContentAdd from 'material-ui/svg-icons/content/add'
import TemplateForm from '../templateForm'
import Error from 'components/Error'
import loginActions from 'actions/login'

let select = (state) => ({
    ...state,
	templates: templates(state),
	actionBarReducers: state.actionBarReducers,
	projectFilters: state.projectFiltersReducers
  })

export class Templates extends Component {
	render(){
		try {
			return(
				<TemplatesList
					templates={this.props.templates}
					openPanel={this.props.OPEN_PANEL}
					filtersIsOpened={false}
					rightStackOpened={!!this.props.routeParams.id}
					navPanelIsOpened={this.props.actionBarReducers.leftNav}
					lastInteracted={(this.props.routeParams.id)?
						this.props.routeParams.id
						: ''
					}
					count={(this.props.templates)? R.values(this.props.templates).length: 0}
				/>
			)
		}catch(err){
			console.error(err)
			return(<Error />)
		}
	}
}

export default connect(select, R.mergeAll([actionBarActions, dataActions, loginActions]))(Templates)



// WEBPACK FOOTER //
// ./src/routes/manager/templates/index.js